/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2024-08-16 16:36:27
 * @FilePath: \crane-safety-manager\src\Libs\value_enum.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const USER_ROLE_VALUE_ENUM = {
  SystemAdmin:"测试人员",
  Admin: "总监理",
  Supervisor: "总管理员",
  ProjectAdmin: "项目管理员",
  ProjectSupervisor: "设备管理员",
};
